import { HttpErrorResponse } from '@angular/common/http';
import { RetryConfig, timer } from 'rxjs';

const retryOn = new Set([
  403,  // forbidden (but is returned by stopped/restarting azure app service)
  408,  // request timeout
  429,  // too many requests
  502,  // bad gateway
  503,  // service unavailable
  504   // gateway timeout
]);

export const retryConfig: RetryConfig = {
  count: 3,
  delay: (error: any, _: number) => {
    if (error instanceof HttpErrorResponse && retryOn.has(error.status)) {
      let delay = 100; // ms

      if (error.headers.has('Retry-After')) {
        const value = error.headers.get('Retry-After');
        if (value) {
          const seconds = Number.parseInt(value);
          if (!Number.isNaN(seconds) && seconds > 0)
            delay = seconds * 1000;
        }
      }

      return timer(delay);
    }

    throw error;
  }
};
